import { storeToRefs } from "pinia";
import { dict, type MsgKey } from "@/i18n/strings";
import { fill } from "@/i18n/text";
import { useLocaleStore, type AppLocale } from "@/store/locale";

/**
 * 界面三语文案：按 locale store 从原型字典取值。
 * 模板中调用 t() 会追踪当前语言，切换后自动重渲染。
 */
export function useI18n() {
  const localeStore = useLocaleStore();
  const { locale } = storeToRefs(localeStore);

  /** 取当前语言对应文案 */
  const t = (key: MsgKey): string => dict[key][locale.value];

  /** 取当前语言文案并替换 `{name}` 占位 */
  const tf = (key: MsgKey, vars: Record<string, string | number>): string => fill(t(key), vars);

  return {
    locale,
    t,
    tf,
    setLocale: (next: AppLocale) => localeStore.setLocale(next),
  };
}
